"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.makeFlexSchemaPropTypes = void 0;

var _reactDesc = require("react-desc");

var _spacingSchema = require("../../modifiers/spacingSchema");

var _breakpointSizeSchema = require("../../modifiers/breakpointSizeSchema");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeFlexSchemaPropTypes = function makeFlexSchemaPropTypes() {
  return _objectSpread({
    alignContent: _reactDesc.PropTypes.string.description('Defines the `align-content` CSS property.'),
    alignItems: _reactDesc.PropTypes.string.description('Defines the `align-items` CSS property.'),
    alignSelf: _reactDesc.PropTypes.string.description('Defines the `align-self` CSS property.'),
    flexBasis: _reactDesc.PropTypes.string.description('Defines the `flex-basis` CSS property.'),
    flexDirection: _reactDesc.PropTypes.string.description('Defines the `flex-direction` CSS property.'),
    flexGrow: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.string, _reactDesc.PropTypes.number]).description('Defines the `flex-grow` CSS property.'),
    flexShrink: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.string, _reactDesc.PropTypes.number]).description('Defines the `flex-shrink` CSS property.'),
    flexWrap: _reactDesc.PropTypes.string.description('Defines the `flex-wrap` CSS property.'),
    flex: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.string, _reactDesc.PropTypes.number]).description('Defines the `flex` CSS property.'),
    justifyContent: _reactDesc.PropTypes.string.description('Defines the `justify-content` CSS property.'),
    justifyItems: _reactDesc.PropTypes.string.description('Defines the `justify-items` CSS property.'),
    justifySelf: _reactDesc.PropTypes.string.description('Defines the `justify-self` CSS property.'),
    order: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.string, _reactDesc.PropTypes.number]).description('Defines the `order` CSS property. Must be a valid CSS `order` value.')
  }, (0, _spacingSchema.makeSpacingSchemaPropTypes)(), {}, (0, _breakpointSizeSchema.makeBreakpointSizePropTypes)(), {
    zIndex: _reactDesc.PropTypes.number.description('Defines the z-index of the element.')
  });
};

exports.makeFlexSchemaPropTypes = makeFlexSchemaPropTypes;
var schema = (0, _reactDesc.describe)({
  displayName: 'Flex'
});
schema.propTypes = makeFlexSchemaPropTypes();
var _default = schema;
exports.default = _default;